import React from 'react';

import SessionSearchBanner from './SessionSearchBanner';
import PrepToolBanner from './PrepToolBanner';

const SummaryBanner = ({ openSession }) => (openSession ? <SessionSearchBanner /> : <PrepToolBanner />);

export default SummaryBanner;
